import { ParagraphPlaceholder, ParagraphPlaceholderProps } from 'app/components/paragraph-placeholder';
import { defaultParagraphPlaceholderStyles } from 'app/components/paragraph-placeholder/default-paragraph-placeholder-styles';
import { withUpdatedTheme } from 'app/components/theme';

export const StyledContentPlaceholder = withUpdatedTheme<ParagraphPlaceholderProps>({
    paragraphPlaceholder: {
        ...defaultParagraphPlaceholderStyles,
        container: {
            ...defaultParagraphPlaceholderStyles.container,
            marginBottom: '237px',
        },
        paragraph: {
            ...defaultParagraphPlaceholderStyles.paragraph,
            width: '372px',
        },
    },
})(ParagraphPlaceholder);
